import { useId, useState } from 'react';

import cn from 'classnames';

import { UiButton } from '@shared/ui';

import cls from './OrdersContent.module.css';
import { OrderDetails } from '../OrderDetails';

import type { Order } from '@entities/order';

type OrdersContentProps = {
    orders: Order[];
};

export const OrdersContent = ({ orders }: OrdersContentProps) => {
    const tabsId = useId();
    const [selectedOrderId, setSelectedOrderId] = useState(orders[0].id);
    const selectedOrder = orders.find(({ id }) => id === selectedOrderId) ?? orders[0];

    return (
        <main className={cls.ordersContent}>
            <div className={cls.tabs} role="tablist">
                {orders.map((order) => {
                    const isSelected = order.id === selectedOrder.id;

                    return (
                        <UiButton
                            key={order.id}
                            id={`${tabsId}-tab-${order.id}`}
                            type="button"
                            variant="text"
                            className={cn(cls.tab, isSelected && cls.activeTab)}
                            btnText={order.name}
                            role="tab"
                            aria-selected={isSelected}
                            aria-controls={`${tabsId}-panel-${order.id}`}
                            onClick={() => setSelectedOrderId(order.id)}
                        />
                    );
                })}
            </div>
            <div
                id={`${tabsId}-panel-${selectedOrder.id}`}
                role="tabpanel"
                aria-labelledby={`${tabsId}-tab-${selectedOrder.id}`}
            >
                <OrderDetails order={selectedOrder} />
            </div>
        </main>
    );
};
